<auth-header></auth-header>
<form 
    *ngIf="!submitted"
    #form="ngForm"
    (ngSubmit)="onSubmit(form)"
    novalidate>
    <h1>Password Recovery</h1>
    <ui-input>
        <input
            uiInput
            type="email"
            name="email"
            #email="ngModel"
            [(ngModel)]="model.email"
            (ngModelChange)="onHideError()"
            placeholder="Email"
            emailValidator
            maxlength="264"
            required />
        <ui-input-error [input]="email" name="required">Email is required</ui-input-error>
        <ui-input-error [input]="email" name="email">Email is invalid</ui-input-error>
    </ui-input>
    <div class="ui-input-error" *ngIf="error" [ngSwitch]="error" [class.visible]="error">
            <span *ngSwitchCase="'invalidGrant'">Invalid email or password</span>
            <span *ngSwitchCase="'userNotActivated'">Check your email to complete registration</span>
            <span *ngSwitchCase="'userIsBlocked'">User was blocked by account administrator</span>
            <span *ngSwitchCase="'userNotExists'">User with this email doesn't exist in the system</span>
    </div>
    <input type="checkbox" name="checkbox" id="def-checkbox" class="def-checkbox" onchange="document.getElementById('register').disabled = this.checked;" />
    <button type="submit" id="register" class="default" (click)="validate(form)">Submit</button>
    <ui-loading *ngIf="processing"></ui-loading>
</form>
<div *ngIf="submitted" class="submitted-dialog">
    <h1>You have requested to change your password</h1>
    <p>Password recovery instructions have been sent to your email address.</p>
    <p>If you do not receive this email message in a few minutes, check your junk email folder. 
        If you find our message in the junk folder, make sure you indicate that it is not junk 
        to ensure that you receive our future messages.</p>
    <button class="default" (click)="onOk()">OK</button>
</div>
<auth-footer></auth-footer>